import type { ElementType, FunctionComponent } from 'react';
import { Spinner } from '../Spinner';
import { ButtonContent, StyledButton } from './Button.styles';
import type { ButtonProps, LinkButtonProps } from './Button.types';

/* `as` does not widen a Linaria component's props, so the anchor's shape is asserted once here. */
const StyledLink = StyledButton as unknown as FunctionComponent<
  LinkButtonProps & { $fullWidth: boolean; as: ElementType }
>;

export const Button = (props: ButtonProps) => {
  if (props.href !== undefined) {
    const {
      variant = 'primary',
      size = 'medium',
      fullWidth = false,
      href,
      linkComponent = 'a',
      children,
      ...rest
    } = props;

    return (
      <StyledLink
        as={linkComponent}
        href={href}
        data-variant={variant}
        data-size={size}
        $fullWidth={fullWidth}
        {...rest}
      >
        <ButtonContent>{children}</ButtonContent>
      </StyledLink>
    );
  }

  const {
    variant = 'primary',
    size = 'medium',
    fullWidth = false,
    selected,
    loading = false,
    disabled,
    children,
    ...rest
  } = props;

  return (
    <StyledButton
      data-variant={variant}
      data-size={size}
      $fullWidth={fullWidth}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...(selected !== undefined
        ? { 'aria-pressed': selected, 'data-selected': selected || undefined }
        : {})}
      {...rest}
    >
      <ButtonContent>
        {loading && <Spinner aria-hidden />}
        {children}
      </ButtonContent>
    </StyledButton>
  );
};
